var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailTransactionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 0C3.3525 0 0 3.3525 0 7.5C0 11.6475 3.3525 15 7.5 15C11.6475 15 15 11.6475 15 7.5C15 3.3525 11.6475 0 7.5 0ZM8.9175 5.025L7.5 6.4425L6.0825 5.025C5.79 4.7325 5.3175 4.7325 5.025 5.025C4.7325 5.3175 4.7325 5.79 5.025 6.0825L6.4425 7.5L5.025 8.9175C4.7325 9.21 4.7325 9.6825 5.025 9.975C5.3175 10.2675 5.79 10.2675 6.0825 9.975L7.5 8.5575L8.9175 9.975C9.21 10.2675 9.6825 10.2675 9.975 9.975C10.2675 9.6825 10.2675 9.21 9.975 8.9175L8.5575 7.5L9.975 6.0825C10.2675 5.79 10.2675 5.3175 9.975 5.025C9.6825 4.74 9.2025 4.74 8.9175 5.025ZM1.5 7.5C1.5 10.8075 4.1925 13.5 7.5 13.5C10.8075 13.5 13.5 10.8075 13.5 7.5C13.5 4.1925 10.8075 1.5 7.5 1.5C4.1925 1.5 1.5 4.1925 1.5 7.5Z",
    fill: "#D42F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailTransactionIcon);
export default __webpack_public_path__ + "static/media/fail-transaction-icon.0b01941a3aa6a045774add82ae7785d2.svg";
export { ForwardRef as ReactComponent };